// Header Cart component
const HeaderCart = {
  data() {
    return {
      show: false,
      items: [],
    };
  },
  computed: {
    localStorageList() {
      return JSON.parse(localStorage.getItem('cart'));
    },
    cartSum() {
      let sum = 0;
      this.items.forEach((item) => {
        sum += item.quantity * item.price;
      });

      return sum;
    },
  },
  methods: {
    toggle() {
      this.show = !this.show;
    },
    addItem(event) {
      const newItemQuantityEl = document.getElementById(
        `p-${event.target.dataset.id}-quantity`
      );

      let newItemQuantity = 1;
      if (newItemQuantityEl) {
        newItemQuantity = parseInt(newItemQuantityEl.value);
      }

      const newItem = {
        id: event.target.dataset.id,
        name: event.target.dataset.name,
        price: event.target.dataset.price,
        image: event.target.dataset.image,
        quantity: newItemQuantity,
        time_added: Date.now(),
      };

      const alreadyInCart = this.items.find((item) => item.id == newItem.id);

      if (alreadyInCart && alreadyInCart.quantity) {
        alreadyInCart.quansameAsShippingAddresstity =
          parseInt(alreadyInCart.quantity) + newItemQuantity;
      } else {
        this.items.push(newItem);
      }

      this.updateLocalStorage();
    },
    removeItem(id) {
      this.items = this.items.filter((item) => item.id !== id);
      this.updateLocalStorage();
    },
    onQuantityChange(event) {
      this.updateLocalStorage();
    },
    updateLocalStorage() {
      localStorage.setItem('cart', JSON.stringify(this.items));
    },
  },
  watch: {
    localStorageList(newValue) {
      // console.log(newValue);
      this.items = this.localStorageList || [];
    },
  },
  async mounted() {
    this.items = this.localStorageList || [];

    // Update item prices if needed
    const itemsToUpdate = this.items.filter(
      (item) => Date.now() - item.time_added > 1000 * 60 * 60
    );

    if (itemsToUpdate.length > 0) {
      try {
        const formData = new FormData();
        itemsToUpdate.forEach((item) => {
          formData.append('ids[]',item.id);
        });
        const priceDataJSON = await fetch('/checks/update-cart', {
          method: 'POST',
          body: formData
        });

        const priceData = priceDataJSON.ok ? await priceDataJSON.json() : null;

        if (priceData) {
          for (const obj of priceData) {

            if (obj.price) {
              const cartItem = this.items.find((item) => item.id ==obj.id);
              if (cartItem) {
                cartItem.price = obj.price;
              }
            } else {
              this.items = this.items.filter((item) => item.id !== obj.id);
            }
          }
        }

        this.updateLocalStorage();
      } catch (error) {
        // ?...
      }
    }
  },
};

// Cart page component - deep copy of HeaderCart
const CartPage = {
  ...HeaderCart,
  methods: {
    ...HeaderCart.methods,
    async checkOrder() {
      // Store item-quantity pairs in a FormData
      const formData = new FormData();
      this.items.forEach((item) => {
        formData.append(item.id, item.quantity);
      });

      try {
        const orderDetailsJSON = await fetch('/checks/start-order', {
          method: 'POST',
          body: formData,
        });

        const orderDetails = await orderDetailsJSON.json();
        if (orderDetails.success && orderDetails.redirect) {
          window.location.href = orderDetails.redirect;
        }
      } catch (error) {
        // ?...
        // TODO
      }
    },
  },
};

// Cart summary page
const CartSummaryPage = {
  data() {
    return {
      errorMessage: null,
      cartSummary: null,
      isCompany: 0,
      companyName: '',
      taxNumber: '',
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      country: '',
      zipCode: null,
      city: '',
      address: '',
      shippingMethod: null,
      paymentMethod: null,
      sameAsShippingAddress: true,
      shippingCompanyName: this.companyName,
      shippingFirstName: this.firstName,
      shippingLastName: this.lastName,
      shippingZipCode: this.zipCode,
      shippingCity: this.city,
      shippingAddress: this.address,
      acceptedTerms: false,
    };
  },
  computed: {
    shippingPrice() {
      const method = this.cartSummary?.shipping_methods.find(
        (method) => method.id === this.shippingMethod
      );
      return method ? method.price_with_tax : 0;
    },
    shippingTax() {
      const method = this.cartSummary?.shipping_methods.find(
        (method) => method.id === this.shippingMethod
      );
      return method ? method.tax : 0;
    },
  },
  methods: {
    sameAsShippingAddressChange() {
      if (this.sameAsShippingAddress ) {
        this.shippingFirstName = this.firstName;
        this.shippingLastName = this.lastName;
        this.shippingCompanyName = this.companyName;
        this.shippingZipCode = this.zipCode;
        this.shippingCity = this.city;
        this.shippingAddress = this.address;
      } else {
        this.shippingFirstName = '';
        this.shippingLastName = '';
        this.shippingCompanyName = '';
        this.shippingZipCode = '';
        this.shippingCity = '';
        this.shippingAddress = '';
      }
    },
    shippingMethodChange() {
      let shipping_type = this.cartSummary.shipping_methods.find(
        (element) => element.id == this.shippingMethod
      ).shipping_type;

      if (shipping_type > 1) {
        if (!document.getElementById('shipping-' + shipping_type)) {
          var script = document.createElement('script');
          script.onload = function () {
            // window['shipping_'+shipping_type].load();
            shipping_2.load();
          };

          script.id = 'shipping-' + shipping_type;
          script.src =
            '/core/javascript/shipping/shipping-' + shipping_type + '.js';

          document.head.appendChild(script);
        } else {
          shipping_2.load();
        }
      }
    },
    setGLSAddress(data) {
      alert(data.city);
      this.shippingFirstName = this.firstName;
      this.shippingLastName = this.lastName;
      this.shippingZipCode = data.zipcode;
      this.shippingCity = data.city;
      this.shippingAddress = data.address;
    },
    async finishOrder() {
      const method = this.cartSummary?.shipping_methods.find(
          (method) => method.id === this.shippingMethod
      );

      if (this.sameAsShippingAddress && method.shipping_type === 1) {
        this.shippingFirstName = this.firstName;
        this.shippingLastName = this.lastName;
        this.shippingCompanyName = this.companyName;
        this.shippingZipCode = this.zipCode;
        this.shippingCity = this.city;
        this.shippingAddress = this.address;
      }else  if (this.sameAsShippingAddress && method.shipping_type > 1) {
        this.shippingFirstName = this.firstName;
        this.shippingLastName = this.lastName;
      }else if(method.shipping_type === null){
          this.shippingFirstName = '';
          this.shippingLastName = '';
          this.shippingCompanyName = '';
          this.shippingZipCode = '';
          this.shippingCity = '';
          this.shippingAddress = '';
      }
      const data = {
        is_company: this.isCompany,
        company_name: this.companyName,
        tax_number: this.taxNumber,
        first_name: this.firstName,
        last_name: this.lastName,
        email: this.email,
        phone: this.phone,
        country: this.country,
        zip_code: this.zipCode,
        city: this.city,
        address: this.address,
        shipping_method: this.shippingMethod,
        payment_method: this.paymentMethod,
        shipping_first_name: this.shippingFirstName,
        shipping_last_name: this.shippingLastName,
        shipping_company_name: this.shippingCompanyName,
        shipping_zip_code: this.shippingZipCode,
        shipping_city: this.shippingCity,
        shipping_address: this.shippingAddress,
        accepted_terms: this.acceptedTerms,
      };

      // Building the FormData...
      const formData = new FormData();

      for (const [key, value] of Object.entries(data)) {
        formData.append(key, value);
      }

      try {
        const orderJSON = await fetch('/checks/finish-order', {
          method: 'POST',
          body: formData,
        });
        const order = await orderJSON.json();

        // Itt majd lehet valamit kezdeni a válasszal
        console.log(order);
        if (order.redirect) {
          localStorage.removeItem('cart');
          location.href = order.redirect;
        }
        if (order.message) {
          this.errorMessage = order.message;
        }
      } catch (error) {
        // ?...
        // TODO
      }
    },
  },
  async mounted() {
    try {
      const cartSummaryJSON = await fetch('/checks/get-order');
      const cartSummary = await cartSummaryJSON.json();

      if (cartSummary.success) {
        this.cartSummary = cartSummary;
      } else {
        if (cartSummary.redirect) {
          location.href = cartSummary.redirect;
        }
      }
    } catch (error) {
      // ?...
      // TODO
    }
  },
};

// Global cart object
const CART = {
  vue: null,
  loadHeaderCard() {
    this.vue = Vue.createApp(HeaderCart).mount('#cart-icon');
  },
  loadCartPage() {
    this.vue = Vue.createApp(CartPage).mount('#cart-page-list');
  },
  loadCartSummaryPage() {
    this.vue = Vue.createApp(CartSummaryPage).mount('#cart-summary-page');
  },
};
window.CART = CART;
const loadVue = () => {
  // Header cart
  CART.loadHeaderCard();

  // Cart page
  if (document.getElementById('cart-page-list')) {
    CART.loadCartPage();
  }

  // Cart summary page
  if (document.getElementById('cart-summary-page')) {
    CART.loadCartSummaryPage();
  }

  // Registering event listeners
  const buttons = document.getElementsByClassName('p-add-to-cart');

  for (let button of buttons) {
    button.addEventListener('click', (event) => CART.vue.addItem(event));
  }
};

window.addEventListener('DOMContentLoaded', () => {
  loadVue();
});

if (document.readyState !== 'loading') {
  loadVue();
}
